import axios from 'axios';
import Chart from 'chart.js';
import 'chartjs-plugin-zoom';
import Chartkick from 'chartkick';
import 'hammerjs';

Chartkick.use(Chart);

const start = moment();
const end = moment();

const formatReportChartDate = function (start, end) {
  $('#consumption_variation_per_order_daterange span')
    .html(`${start.format('MMMM D, YYYY')} - ${end.format('MMMM D, YYYY')}`)
    .trigger('change');
};

const updateConsumptionVariationPerOrderChart = function () {
  const params = {
    start_at: moment(
      $('#consumption_variation_per_order_daterange span')
        .text()
        .split(' - ')[0],
      'MMMM D, YYYY'
    ).format(),
    end_at: moment(
      $('#consumption_variation_per_order_daterange span')
        .text()
        .split(' - ')[1],
      'MMMM D, YYYY'
    ).format(),
    product_id: $('#consumption_variation_per_order_product_id').val(),
  };

  axios
    .get('/production_reports/consumption_variation_per_order', {
      params,
    })
    .then(response => {
      const chart = Chartkick.charts['consumption-variation-per-order-chart'];
      chart.updateData([response.data[0]]);
      $('#variation-mean-2').html(response.data[1]);
      $('#variation-std-deviation-2').html(response.data[2]);
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

const updateOrderConsumptionVariationPerBatchChart = function () {
  const params = {
    product_id: $('#order_consumption_variation_per_batch_product_id').val(),
    production_order_code: $(
      '#order_consumption_variation_per_batch_production_order_code'
    ).val(),
  };

  axios
    .get('/production_reports/order_consumption_variation_per_batch', {
      params,
    })
    .then(response => {
      const chart = Chartkick.charts['consumption-variation-per-batch-chart'];
      chart.updateData([response.data[0]]);
      $('#variation-mean').html(response.data[1]);
      $('#variation-std-deviation').html(response.data[2]);
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

const updateRawMaterialsByOrder = async () => {
  try {
    const res = await axios.get('/raw_materials_by_production_order', {
      params: {
        production_order_code: $(
          '#order_consumption_variation_per_batch_production_order_code'
        ).val(),
      },
    });
    const rawMaterials = res.data;
    const rawMaterialSelect = $(
      '#order_consumption_variation_per_batch_product_id'
    );
    $(
      '#order_consumption_variation_per_batch_product_id option:not(:first)'
    ).remove();
    rawMaterials.forEach(rawMaterial => {
      rawMaterialSelect.append(
        $('<option>', {
          text: rawMaterial.code_and_name,
          value: rawMaterial.id,
        })
      );
    });
    rawMaterialSelect.trigger('change');
  } catch (error) {
    console.log(error.response.data);
  }
};

const updateRecipeVersionSelect = async (recipeCode, recipeVersionSelect) => {
  try {
    const res = await axios.get('/recipes.json', {
      params: { code: recipeCode },
    });
    recipeVersionSelect.empty();
    res.data.forEach(recipe => {
      recipeVersionSelect.append(
        $('<option>', {
          text: recipe.version,
          value: recipe.version,
        })
      );
    });
    recipeVersionSelect.trigger('change');
  } catch (error) {
    console.log(error);
  }
};

document.addEventListener('turbolinks:load', function () {
  // Format daterange of charts
  $('.production_chart_predefined_daterange').daterangepicker(
    {
      startDate: start,
      endDate: end,
      locale: {
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        customRangeLabel: 'Rango personalizado',
      },
      showDropdowns: true,
      ranges: {
        Hoy: [moment().startOf('day'), moment().endOf('day')],
        Ayer: [
          moment().subtract(1, 'days').startOf('day'),
          moment().subtract(1, 'days').endOf('day'),
        ],
        'Últimos 7 días': [
          moment().subtract(6, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        'Últimos 30 días': [
          moment().subtract(29, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        'Este mes': [moment().startOf('month'), moment().endOf('month')],
        'Mes pasado': [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month'),
        ],
      },
    },
    formatReportChartDate
  );
  formatReportChartDate(start, end);

  $('#order_consumption_variation_per_batch_production_order_code').on(
    'change',
    updateRawMaterialsByOrder
  );

  // order_consumption_variation_per_batch chart
  $('#order_consumption_variation_per_batch_production_order_code').on(
    'change',
    updateOrderConsumptionVariationPerBatchChart
  );
  $('#order_consumption_variation_per_batch_product_id').on(
    'change',
    updateOrderConsumptionVariationPerBatchChart
  );
  $('#consumption-variation-per-batch-zoom-reset-btn').on('click', function () {
    Chartkick.charts['consumption-variation-per-batch-chart'].chart.resetZoom();
  });

  // consumption_variation_per_order chart
  $('#consumption_variation_per_order_daterange span').on(
    'change',
    updateConsumptionVariationPerOrderChart
  );
  $('#consumption_variation_per_order_product_id').on(
    'change',
    updateConsumptionVariationPerOrderChart
  );
  $('#consumption-variation-per-order-zoom-reset-btn').on('click', function () {
    Chartkick.charts['consumption-variation-per-order-chart'].chart.resetZoom();
  });

  // daily_production report
  $('#report-by-plant-1, #report-by-client-1').hide();
  $('#by_plant_check_1').on('click', function () {
    $('#report-by-plant-1').toggle(this.checked);
  });
  $('#by_client_check_1').on('click', function () {
    $('#report-by-client-1').toggle(this.checked);
  });
  $('#report-by-recipe-1, #report-by-plant-2').hide();
  $('#by_recipe_check_1').on('click', function () {
    $('#report-by-recipe-1').toggle(this.checked);
  });
  $('#by_plant_check_2').on('click', function () {
    $('#report-by-plant-2').toggle(this.checked);
  });

  // consumption_per_recipe report
  $('#report_product_ids_1').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    width: '100%',
  });
  $('#report_ingredient_ids_1').select2({
    placeholder: 'Buscar una materia prima (código o nombre)',
    width: '100%',
  });
  $('#report_recipe_id_3').select2({
    placeholder: 'Buscar una receta (código, nombre o versión)',
    minimumInputLength: 3,
    width: '100%',
  });
  $(
    '#report-by-plant-3, #report-by-selected-ingredients, #report-by-recipe-version'
  ).hide();
  $('#by_plant_check_3').on('click', function () {
    $('#report-by-plant-3').toggle(this.checked);
  });
  $('#by_selected_ingredients').on('click', function () {
    $('#report-by-selected-ingredients').toggle(this.checked);
  });
  $('#by_recipe_version_check').on('click', function () {
    $('#report-by-recipe-version').toggle(this.checked);
  });
  $('#report_recipe_code_1').on('change', function () {
    const recipeCode = $('#report_recipe_code_1').val();
    const recipeVersionSelect = $('#report_recipe_version');
    updateRecipeVersionSelect(recipeCode, recipeVersionSelect);
  });

  // consumption_per_ingredient_per_order
  $('#report_ingredient_id_1').select2({
    placeholder: 'Buscar una materia prima (código o nombre)',
    width: '100%',
  });
  $('#report-by-plant-4').hide();
  $('#by_plant_check_4').on('click', function () {
    $('#report-by-plant-4').toggle(this.checked);
  });

  // consumption_per_product report
  $('#report-by-plant-5, #report-by-selected-products').hide();
  $('#by_plant_check_5').on('click', function () {
    $('#report-by-plant-5').toggle(this.checked);
  });
  $('#by_selected_products').on('click', function () {
    $('#report-by-selected-products').toggle(this.checked);
  });

  // consumption_per_client report
  $('#report-by-plant-6').hide();
  $('#by_plant_check_6').on('click', function () {
    $('#report-by-plant-6').toggle(this.checked);
  });

  // production_per_recipe report
  $('#report-by-plant-8, #report-by-recipe-version-2').hide();
  $('#by_plant_check_8').on('click', function () {
    $('#report-by-plant-8').toggle(this.checked);
  });
  $('#by_recipe_version_check_2').on('click', function () {
    $('#report-by-recipe-version-2').toggle(this.checked);
  });
  $('#report_recipe_code_2').on('change', function () {
    const recipeCode = $('#report_recipe_code_2').val();
    const recipeVersionSelect = $('#report_recipe_version_2');
    updateRecipeVersionSelect(recipeCode, recipeVersionSelect);
  });
  $('#report_recipe_id_4').select2({
    placeholder: 'Buscar una receta (código, nombre o versión)',
    minimumInputLength: 3,
    width: '100%',
  });

  // production_per_client report
  $('#report_product_ids_4').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    width: '100%',
  });
  $('#report-by-plant-9, #report-by-selected-products-2').hide();
  $('#by_plant_check_9').on('click', function () {
    $('#report-by-plant-9').toggle(this.checked);
  });

  $('#by-selected-products-check-3').on('click', function () {
    $('#report-by-selected-products-2').toggle(this.checked);
  });

  // micro_ingredient_orders_summary
  $('#report_recipe_id_5').select2({
    placeholder: 'Buscar una receta (código, nombre o versión)',
    minimumInputLength: 3,
    width: '100%',
  });

  // micro_ingredient_order_batch_details report
  $('#report_ingredient_ids_2').select2({
    placeholder: 'Buscar una materia prima (código o nombre)',
    width: '100%',
  });
  $('#report_recipe_id_2').select2({
    placeholder: 'Buscar una receta (código, nombre o versión)',
    minimumInputLength: 3,
    width: '100%',
  });

  // weighing_by_micro_ingredients report
  $('#report_ingredient_ids_3').select2({
    placeholder: 'Buscar una materia prima (código o nombre)',
    width: '100%',
  });
  $('#report_recipe_id_6').select2({
    placeholder: 'Buscar una receta (código, nombre o versión)',
    minimumInputLength: 3,
    width: '100%',
  });
});
